<vt-base64-image-display [imageSource]="thumbnail$ | async"></vt-base64-image-display>

<a *ngIf="this.thumbnail" (click)="deleteThumbnail()"> <i class="material-icons" aria-hidden="true"> delete </i> </a>
<button type="button" md-button (click)="imgFileInput.click()">Upload</button>
<input hidden type="file" #imgFileInput accept=".png,.svg" (change)="changeThumbnail($event)" name="thumbnailFile" />
